<template>
  <div>
    <div v-if="showApplicationQuestions">
      <h2 class="mb-5">
        Review Application
      </h2>
      <div class="secondary-text mb-5">
        Before submitting your application, please review your responses to the
        application questions
      </div>
      <ApplicationQuestionsWithAnswers
        :applicationId="currentUserApplication.id"
        :bookingId="currentBooking.id"
        pointedList
      />
    </div>
    <div v-else>
      <v-img
        :src="require('@/assets/svg/confirmation-icon.svg')"
        class="mb-5 mt-5"
        height="140"
        contain
      />
      <h2 class="mb-2 d-flex justify-center text-center mb-5">
        Do you want to submit an application for
        {{ currentBooking.title }}?
      </h2>
    </div>
    <div
      class="d-flex justify-end"
      :class="{ 'justify-center': !showApplicationQuestions }"
    >
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Submit Application
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ApplicationQuestionsWithAnswers from "@/components/workers/ApplicationQuestionsWithAnswers";
import { UNSORT_APPLICATION } from "@/store/modules/applications/actions";
import { APPLICATION_NAMESPACE } from "@/store/modules/applications";
import { createNamespacedHelpers } from "vuex";
import { size } from "lodash";
import { BOOKINGS_NAMESPACE } from "@/store/modules/bookings/actions";
import {
  GET_CURRENT_USER_APPLICATION,
  GET_BOOKING_APPLICATION_QUESTIONS
} from "@/store/modules/applications/getters";
import { GET_CURRENT_BOOKING } from "@/store/modules/bookings/getters";

const { mapGetters: mapBookingGetters } = createNamespacedHelpers(
  BOOKINGS_NAMESPACE
);

const {
  mapActions: mapApplicationActions,
  mapGetters: mapApplicationGetters
} = createNamespacedHelpers(APPLICATION_NAMESPACE);

export default {
  name: "ApplicationConfirmation",
  components: {
    PrimaryButton,
    ApplicationQuestionsWithAnswers
  },
  created() {
    this.emitProgressValue(100);
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapBookingGetters({
      currentBooking: GET_CURRENT_BOOKING
    }),
    ...mapApplicationGetters({
      currentUserApplication: GET_CURRENT_USER_APPLICATION,
      bookingApplicationQuestions: GET_BOOKING_APPLICATION_QUESTIONS
    }),
    showApplicationQuestions() {
      return size(this.bookingApplicationQuestions);
    }
  },
  methods: {
    ...mapApplicationActions({
      unsortApplication: UNSORT_APPLICATION
    }),
    async nextStep() {
      this.isLoading = true;
      await this.unsortApplication(this.currentUserApplication.id);
      this.isLoading = false;
      this.$router.push("application-submitted");
    },
    emitProgressValue(value) {
      this.$emit("onStepChanged", {
        progressValue: value
      });
    },
    stepBack() {
      this.emitProgressValue(0);
    }
  }
};
</script>

<style lang="scss"></style>
